import { Link } from "react-router-dom";
import css from './index.module.css';
import SEO from "@components/seo";

export default function EmptyCart () {
  return (
    <div className={css.container}>
        <SEO 
            title="Корзина пуста"
            description="Рыбный мир"
            ogUrl="https://рыбныимир.рф/"
        />

        <div className={css.component}>        
            <div>    
                <h1 style={{ marginBottom: 15 }}>Корзина пустая</h1>
                <a>Добавьте что-нибудь в корзину и возвращайтесь сюда</a>

                <Link to={`/webapp`} className={css.back}>Вернуться на главную</Link>
            </div>
        </div>

    </div>
  )
}
